import { useState } from 'react';
import { IconArrowRight, IconDownload, IconTrash, IconSelected } from '@ui/src';
import { DocumentInfoControlsTypes } from '../types';
import { CustomerStatus } from '../../../../hoc/common/types';

import cn from '../styles.module.css';

const InfoControls = ({
  group,
  setDeletePopupVisible,
  onMove,
  onDownload,
  deleteIsVisible,
  moveInProgress,
  allowedCategories,
  documentCategoryId,
  status,
}: DocumentInfoControlsTypes) => {
  const [submenuVisible, setSubmenuVisible] = useState(false);

  return (
    <div className={cn.documentInfoControls}>
      {status !== CustomerStatus.CLOSED && (
        <button
          type="button"
          className={cn.documentInfoButton}
          onClick={() => setSubmenuVisible(!submenuVisible)}
          disabled={moveInProgress}
        >
          <IconArrowRight
            className={cn.documentInfoArrowIcon}
            width={10}
            height={10}
          />
          {moveInProgress ? 'Loading...' : 'Move to group'}
        </button>
      )}

      <button
        type="button"
        className={cn.documentInfoButton}
        onClick={onDownload}
      >
        <IconDownload
          className={cn.documentInfoDownloadIcon}
          width={16}
          height={16}
        />
        Download
      </button>
      {deleteIsVisible && status !== CustomerStatus.CLOSED && (
        <button
          type="button"
          className={`${cn.documentInfoButton} ${cn.documentInfoDeleteButton}`}
          onClick={() => setDeletePopupVisible(true)}
        >
          <IconTrash
            className={cn.documentInfoDeleteIcon}
            width={16}
            height={16}
          />
          Delete
        </button>
      )}

      {submenuVisible && (
        <ul className={cn.selectedDocumentsMenu}>
          <li className={cn.selectedDocumentsMenuTitle}>
            Which group to move document to?
          </li>
          {allowedCategories?.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={`${cn.selectedDocumentsMenuButton} ${
                  group === item.category || documentCategoryId === item.id
                    ? cn.currentGroup
                    : ''
                }`}
                onClick={() => {
                  onMove(item.id);
                  setSubmenuVisible(false);
                }}
              >
                {item.name.includes('Add other document')
                  ? 'Other documents'
                  : item.name}
                {group !== item.category && documentCategoryId !== item.id && (
                  <div className={cn.selectedDocumentsMenuButtonIconWrapper}>
                    Move
                    <IconArrowRight
                      className={cn.selectedDocumentsMenuButtonIcon}
                      width={10}
                      height={10}
                    />
                  </div>
                )}
                {(group === item.category ||
                  documentCategoryId === item.id) && <IconSelected />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default InfoControls;
